import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { sidebarNav } from './data';

export const Sidebar = () => {
  // let { path, url } = useRouteMatch();

  return (
    <SidebarWrap>
      <h3>Menu</h3>

      <br />
      <ul className='navlinks'>
        {sidebarNav.map((navs) => {
          const { id, name, links, icon } = navs;

          return (
            <li key={id} className='nav-link'>
              <Link to={`/admin/dashboard/${links}`}>
                <span>{icon}</span>
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </SidebarWrap>
  );
};

const SidebarWrap = styled.aside`
  width: calc(100% - 80%);
  height: 50vh;
  border: 2px solid ${({ theme }) => theme.a};
  border-radius: 9px;
  padding: 10px;
  margin: 20px;
  z-index: 1;
  overflow-x: hidden;

  .navlinks .nav-link a {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px;
    color: ${({ theme }) => theme.a};
    text-decoration: none;
    text-transform: capitalize;
  }

  .navlinks .nav-link {
    list-style: none;
    background: ${({ theme }) => theme.pale};
    border-radius: 9px;
    padding: 5px 10px;
    margin: 10px 0;
  }

  .navlinks .nav-link a span svg {
    margin-right: 10px;
    height: 20px;
    width: 20px;
  }

  h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: ${({ theme }) => theme.a};
    text-align: left;
    position: sticky;
    padding: 19px 0;
    top: -20px;
    bottom: 0;
    height: auto;
    z-index: 1;
    width: 100vw;
    background: ${({ theme }) => theme.navbar};
  }
`;
